var map = {
	"./Frage1_768x1024.jpg": "d24e",
	"./Frage2_768x1024.jpg": "529c",
	"./Frage3_768x1024.jpg": "a1f4",
	"./Frage4_768x1024.jpg": "e063",
	"./Frage5_768x1024.jpg": "dbf9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ed8";